module.exports = __webpack_public_path__ + "img/ToyFaces_Colored_BG_13.5d19090a.jpg";